import React, { Component } from "react"
import IndexRouter from "./router"
import { withRouter } from "react-router-dom"
import { LocaleProvider } from 'antd'
import enUS from 'antd/lib/locale-provider/en_US'
import $Header from "./components/Header"
import $Menu from "./components/Menu"
import Cookies from 'js-cookie'
import styled from "styled-components"
import authorization from '@/utils/authorization.js'
import request from '@/utils/request'
import { Spin } from 'antd'

const Root = styled.div`
  /* display: grid; */
`

const Main = styled.div`
  position:relative;
  margin-left:230px;
  margin-top:70px;  
  background-color:#f4f5f9;
  padding:20px;
`

const Header = styled($Header)`
  position: fixed;
  top:0;
  left:0;
  width:100%;
  height:70px;
  box-shadow: 0 1px 4px 0 rgba(0,21,41,.12);
  background-color:#ffffff;
  z-index:100;
`
const Menu = styled($Menu)`
  position: fixed;
  top:70px;
  left:0;
  width:230px;
  height:calc(100vh - 70px);
`

const Contain = styled.div`
  background-color:#ffffff;
`

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tokenFetched: false,
      cookiesReady: false
    };
  }
  componentDidMount() {
    authorization.sdkInit(() => this.getToken())
  }
  applyOAuthCookiesFromUrl() {
    const code = new URL(window.location.href).searchParams.get('code')
    const codeChallenge = new URL(window.location.href).searchParams.get('codeChallenge')
    const codeVerifier = new URL(window.location.href).searchParams.get('codeVerifier')
    if (code) {
      Cookies.set('newopkey', code)
    }
    if (codeChallenge || codeVerifier) {
      Cookies.set(
        'codeverifierkey',
        window.account_web_sdk.getCodeVerifier(codeChallenge) || codeVerifier
      )
    }
    return { oauthCode: code }
  }
  async getToken(){
    const { oauthCode } = this.applyOAuthCookiesFromUrl()
    // 同步写入 document.cookie 后再继续；先标记，避免子树在 cookie 未落地前挂载并发请求
    this.setState({ cookiesReady: true })
    const res = await request.get('/api/user/getToken')
    if(res.code === 1) {
      if(oauthCode) {
        authorization.logout()
      } else {
        authorization.login()
      }
    }
    if(res.code === 0) {
      sessionStorage.setItem('lockcard_token', res.info)
    }
    this.setState({tokenFetched:true})
  }
  render() {
    const { tokenFetched, cookiesReady } = this.state
    const {location}=this.props
    const shellReady = tokenFetched && cookiesReady
    return (
      <Spin spinning={!tokenFetched}>
        <Root>
          {
            shellReady&&(
              <div>
                <Header cookiesReady={cookiesReady} />
                <Main>
                  <Contain>
                    <IndexRouter />
                  </Contain>
                </Main>
                <Menu pathname={location.pathname}/>
              </div>
            )
          }
        </Root>
      </Spin>
    )
  }
}

export default withRouter(props=><LocaleProvider locale={enUS}><App {...props}></App></LocaleProvider>)
